/** @jsxImportSource @emotion/react */
import React from 'react'
import { jsx, css } from '@emotion/react'
import xoip_logo from '../../images/xoip-logo.svg'
import xoip_logo_staging from '../../images/xoip-logo-staging.png'

import { isProd } from '../../actions/ui'

export const Logo = ({style}) => {

    const is_prod = isProd()
    return (
        <img src={ is_prod ? xoip_logo : xoip_logo_staging }
             alt="XOIP"
             css={ style || default_style } />
    )

}

const default_style = css`
height: 26px;
`
